var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import getTranslation from '../../../strings/i18n';
import { getSelectPayAccordionAnalyticsProps } from '../../../const/analytics/select-pay';
import getAccordionIcon from '../../../helpers/getAccordionIcon';
import { colors } from '../../../styles/theme';
import BulletedContent from './content';
import { StyledAccordion, StyledAccordionHeader, StyledAccordionHeadingContent } from './subcomponents';
var DetailsAccordion = function () {
    var _a = useState(true), isExpanded = _a[0], setIsExpanded = _a[1];
    var t = getTranslation().t;
    return (_jsx(StyledAccordion, __assign({}, getSelectPayAccordionAnalyticsProps(isExpanded).seeHowItWorks, { id: "select-pay-details", transitionDuration: 0, expanded: isExpanded, headerClickCallBack: function () { return setIsExpanded(function (prev) { return !prev; }); }, header: _jsx(StyledAccordionHeader, { children: _jsxs(StyledAccordionHeadingContent, { alignItems: "center", children: [t('selectPay.detailsAccordionButton'), ' ', _jsx(FontAwesomeIcon, { icon: getAccordionIcon(isExpanded), size: "1x", color: colors.cyanBlue })] }) }), body: _jsx("section", { children: _jsx(BulletedContent, {}) }) })));
};
export default DetailsAccordion;
//# sourceMappingURL=index.js.map